export type SubNavItem = {
    title: string;
    link: string;
    blank?: boolean;
    id?: string;
    callback?: () => void;
};

export type NavItem = {
    title: string;
    link?: string;
    subNav?: SubNavItem[];
    blank?: boolean;
    callback?: () => void;
};

export type SidebarGroupType =
    | 'riskAssessment'
    | 'floodPrediction'
    | 'supports';

export type SidebarDataType = {
    [key in SidebarGroupType]?: NavItem[];
};

export const initialSidebarData: SidebarDataType = {
    floodPrediction: [],
    supports: [],
    riskAssessment: [],
};
